import Keycloak from "keycloak-js";

const keycloakJson = { 
"realm":"techforce",
"url":window._env.REACT_APP_KEYCLOAK_URL,
"ssl-required":"external",
"clientId":"emconsole-frontend-prod",
"public-client":true,
"confidential-port":0
}
const keycloak = Keycloak(keycloakJson);

export default keycloak;